import { render, staticRenderFns } from "./astreintes-planning-jour.vue?vue&type=template&id=e820c61c&scoped=true"
import script from "./astreintes-planning-jour.vue?vue&type=script&lang=js"
export * from "./astreintes-planning-jour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e820c61c",
  null
  
)

export default component.exports